module.exports = __webpack_public_path__ + "media/property-types/Plot_farm-0bff6b3b.png";